module.exports = __webpack_public_path__ + "static/media/Maven_4421.b13caa9d.jpg";